import RequestedDates from '../types/RequestedDates';

const determineIfCustomerWantsMultipleDays = (
    dates?: RequestedDates
): boolean | undefined => {
    if (!dates || !dates.pickupDate || !dates.returnDate) {
        return undefined;
    }

    return dates.pickupDate.compare(dates.returnDate) !== 0;
};

export default determineIfCustomerWantsMultipleDays;
